import { createContext, useContext } from "react";
import { useImmerReducer } from "use-immer";

const initDashListStore = {
  dashboards: {},
  dashboardIds: [],
  isLoadingDashboards: true,
};

function reducer(draft, { type, payload }) {
  switch (type) {
    case "setDashboards": {
      let newState = {};
      for (let i = 0; i < payload.Dashboards.length; i++) {
        let dash = payload.Dashboards[i];
        newState[[dash.id]] = JSON.parse(JSON.stringify(dash));
      }
      draft.dashboards = newState;
      break;
    }
    case "setDashboardIds": {
      draft.dashboardIds = payload;
      break;
    }
    case "moveIdToTopOfList": {
      const oldids = draft.dashboardIds.filter(id => id !== payload)
      const newids = [payload, ...oldids]
      draft.dashboardIds = newids;
      break;
    }
    // when you are creating, you will not have a list of datatables returned
    case "addDashboard": {
      draft.dashboards[[payload.id]] = payload;
      break;
    }
    case "updateDashboard": {
      draft.dashboards[payload.id] = payload;
      break;
    }
    case "updateAccDashPermId": {
      draft.dashboards[payload.dashId].AccountDashboardPermissionId = payload.AccDashPermId;
      break;
    }
    case "updateDashboardUserSetting": {
      let tmpDUSofDashboard = {} 
      draft.dashboards[payload[0].DashboardId].DashboardUserSettings.forEach((dus) => {
        tmpDUSofDashboard[dus.id] = dus
      })
      payload.forEach((dus) => {
        tmpDUSofDashboard[dus.id] = dus
      })
      draft.dashboards[payload[0].DashboardId].DashboardUserSettings = Object.values(tmpDUSofDashboard)
      break;
    }
    // payload: dashId
    case "removeDashboard": {
      delete draft.dashboards[payload];
      break;
    }
    case "updateDashboardDataTables": {
      let newDTs = [];
      if (payload.Dashboards[0].DashboardDataTables.length) {
        for (
          let i = 0;
          i < payload.Dashboards[0].DashboardDataTables.length;
          i++
        ) {
          let dt = payload.Dashboards[0].DashboardDataTables[i];
          newDTs.push(dt);
        }
        draft.dashboards[[payload.Dashboards[0].id]].DashboardDataTables = newDTs;
        draft.dashboards[[payload.Dashboards[0].id]].NEWENVTRY = true
      }
      break;
    }

    // right now we are currently making for 1 dashboard, so its always 0 indexed
    case "createDashboardDataTables": {
      let newDTs = {};
      for (
        let i = 0;
        i < payload.Dashboards[0].DashboardDataTables.length;
        i++
      ) {
        let dt = payload.Dashboards[0].DashboardDataTables[i];
        newDTs[[dt.id]] = dt;
      }
      // should we include all attributes for a dashboard when CREATED?
      // so i can spread the payload for CREATE directly instead of draft
      draft.dashboards[[payload.Dashboards[0].id]] = {
        ...draft.dashboards[[payload.Dashboards[0].id]],
        DashboardDataTables: newDTs,
      };

      break;
    }

    case "setSelectedDashboard": {
      let newDTs = {};
      let newCats = {};
      let copyDraft = payload;
      if (
        payload &&
        payload.DashboardDataTables &&
        Array.isArray(payload.DashboardDataTables)
      ) {
        if (payload.DashboardDataTables.length) {
          payload.DashboardDataTables.forEach((dt) => {
            newDTs[[dt.id]] = dt;
          });
        }
        copyDraft = { ...copyDraft, DashboardDataTables: newDTs };
      }
      // normalized
      else if (
        payload &&
        payload.DashboardDataTables &&
        !Array.isArray(payload.DashboardDataTables)
      ) {
        copyDraft = {
          ...copyDraft,
          DashboardDataTables: payload.DashboardDataTables,
        };
      } else {
        // if endpoint isnt returning categories or datatables -> TODO: refactor to include both
        copyDraft = { ...copyDraft, DashboardDataTables: {} };
      }

      // for categories - TODO: refactor in backend to include categories
      if (
        payload &&
        payload.DashboardCategories &&
        Array.isArray(payload.DashboardCategories)
      ) {
        if (payload.DashboardCategories.length) {
          payload.DashboardCategories.forEach((cat) => {
            newCats[[cat.id]] = cat;
          });
        }
        copyDraft = { ...copyDraft, DashboardCategories: newCats };
      }
      // if normalized
      else if (
        payload &&
        payload.DashboardCategories &&
        !Array.isArray(payload.DashboardCategories)
      ) {
        copyDraft = {
          ...copyDraft,
          DashboardCategories: payload.DashboardCategories,
        };
      } else {
        copyDraft = { ...copyDraft, DashboardCategories: {} };
      }
      draft.selectedDashboard = copyDraft;

      break;
    }

    case "setIsLoadingDashboards": {
      draft.isLoadingDashboards = payload;
      break;
    }

    default: {
      return null;
    }
  }
}

const [DashboardContext, DashboardDispatchContext] = [
  createContext(null),
  createContext(null),
];

export default function DashboardListProvider({ init, children }) {
  const [store, dispatch] = useImmerReducer(
    reducer,
    init || initDashListStore
  );

  return (
    <DashboardContext.Provider value={store}>
      <DashboardDispatchContext.Provider value={dispatch}>
        {children}
      </DashboardDispatchContext.Provider>
    </DashboardContext.Provider>
  );
}

export function useDashboardListStore() {
  return useContext(DashboardContext);
}

export function useDashboardListDispatch() {
  return useContext(DashboardDispatchContext);
}